import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { useQuery } from '../../../../hooks/use-query';
import { useService } from '../../../../services/services';
import React, { Dispatch, SetStateAction, useEffect, useState } from 'react';
import css from './index.module.css';
import Spinner from '../../../../components/common/spinner';
import AnimalEventsList from './animal-events-list';
interface Props {
  useCalendarView: boolean;
  setUseCalendarView: Dispatch<SetStateAction<boolean>>;
  setMissedCountState: Dispatch<SetStateAction<number>>;
}

export default function AnimalEventsCalendar({
  useCalendarView,
  setUseCalendarView,
  setMissedCountState,
}: Props) {
  const { t } = useTranslation();
  const { farmId } = useParams<{ farmId: string }>();
  const [params] = useQuery();
  const { animalService, animalEventService } = useService();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const [furthestYear, setFurthestYear] = useState(0);
  const [missedCount, setMissedCount] = useState(0);
  const [plannedCount, setPlannedCount] = useState(0);
  const [completedCount, setCompletedCount] = useState(0);
  const [noticesCount, setNoticesCount] = useState(0);

  useEffect(() => {
    setLoading(true);
    const year =
      !params?.year || params?.year === ''
        ? new Date().getFullYear()
        : params?.year;
    const month =
      !params?.month || params?.month === ''
        ? String(new Date().getMonth() + 1).padStart(2, '0')
        : params?.month;
    const statuses =
      !params?.statuses || params?.statuses === '' ? '' : params?.statuses;

    animalEventService
      .indexCalendar(farmId, {
        statuses: statuses,
        year: year,
        month: month,
      })
      .subscribe((res) => {
        setData(res.animals_events);
        setMissedCount(res.missed_count);
        setPlannedCount(res.planned_count);
        setCompletedCount(res.completed_count);
        setNoticesCount(res.notices_count);
        setMissedCountState(res.missed_count);
        setLoading(false);
      });

    animalEventService
      .furthestScheduledFarmAnimalEvent(farmId)
      .subscribe((response) => {
        let furthestAnimalEventDate = new Date();
        if (response) {
          let animalEventDate = furthestAnimalEventDate;
          if (response.date && response.date) {
            animalEventDate = new Date(response.date);
          } else if (response.date_to && response.date_to) {
            animalEventDate = new Date(response.date_to);
          }

          if (animalEventDate > furthestAnimalEventDate) {
            furthestAnimalEventDate = animalEventDate;
          }
        }
        setFurthestYear(furthestAnimalEventDate.getFullYear());
      });
  }, [
    animalEventService,
    animalService,
    farmId,
    params?.statuses,
    params?.year,
    params?.month,
    setMissedCountState,
  ]);

  if (loading) {
    return (
      <div className={css['loading']}>
        <div>{t('Loading')}</div>
        <Spinner visible={true} size="lg" />
      </div>
    );
  } else {
    return (
      <AnimalEventsList
        data={data}
        missedCount={missedCount}
        plannedCount={plannedCount}
        completedCount={completedCount}
        noticesCount={noticesCount}
        useCalendarView={useCalendarView}
        setUseCalendarView={setUseCalendarView}
        furthestYear={furthestYear}
      />
    );
  }
}
